import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Loader2, BookOpen } from 'lucide-react';
import UserMenu from '@/components/UserMenu';

export const OfficialsHeader = ({ title, subtitle, children, manualAnchor }) => (
  <header className="bg-white/90 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-2 sm:gap-3">
      <Link to="/my-schedules" className="p-2 -ml-2 rounded-lg text-slate-500 hover:bg-slate-100 transition-colors" data-testid="officials-home-link">
        <Home className="w-5 h-5" />
      </Link>
      <div className="min-w-0 flex-1">
        <h1 className="text-xl sm:text-2xl font-black text-[#00247D] leading-none truncate uppercase" style={{ fontFamily: 'Barlow Condensed' }}
          data-testid="officials-page-title">{title}</h1>
        {subtitle && <p className="text-xs text-slate-500 truncate mt-0.5" data-testid="officials-page-subtitle">{subtitle}</p>}
      </div>
      {children}
      {manualAnchor && (
        <Link to={`/manual/officials#${manualAnchor}`} title="Officials manual" data-testid="officials-manual-link"
          className="inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors">
          <BookOpen className="w-4 h-4" /><span className="hidden lg:inline">Manual</span>
        </Link>
      )}
      <UserMenu inline />
    </div>
  </header>
);

export const OfficialsLoader = ({ text }) => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3 text-slate-500" data-testid="officials-loader">
    <Loader2 className="w-7 h-7 animate-spin text-[#00247D]" />
    {text && <p className="text-sm font-medium">{text}</p>}
  </div>
);
